<template>
    <div>
        <Alert v-if="errors.length > 0" type="danger">
            <div class="side-by-side" v-for="(error, index) in errors" :key="index">
                {{ error }},
            </div>
        </Alert>
    </div>
</template>

<script>
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";

export default {
    name: "ErrorsGoogle",
    props: ["errors"],
    components: {
        Alert
    },
    data() {
        return {
            visible: false,
            timeoutId: null
        };
    },
    watch: {
        errors(newErrors) {
            if (newErrors.length > 0) {
                this.visible = true;

                if (this.timeoutId) clearTimeout(this.timeoutId);

                this.timeoutId = setTimeout(() => {
                    this.visible = false;
                }, 10000); // 10 segundos
            }
        }
    }
};
</script>
